
import React from 'react';
import { buildArr, BreakProps } from './helper';
const Break = ({num =1}: BreakProps): JSX.Element =>
(
    <>
        {
            buildArr(num).map((e) => <br key={e} />)
        }
    </>
)

export default Break;
